import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  IconButton,
  CircularProgress,
  BoxProps,
} from "@mui/material";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import videoIcon from "../../Assets/images/svg/Icons/Group 1488.svg";
import GroupIcon from "../../Assets/images/svg/Icons/Group 578.svg";
import "../../Components/Common/Styles/Formstyles.css";
import { GetApiMethod, DeleteApiMethod } from "../../Utils/ApiService";
import { FormDataType } from "./FormTypes";
const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/";

const normalizeMediaUrl = (url?: string) => {
  if (!url) return "";
  const cleaned = url.replace(/^\/+/, "").replace(/\\/g, "/");
  const base = BASE_URL.endsWith("/") ? BASE_URL : `${BASE_URL}/`;
  return url.startsWith("http") ? url : `${base}${cleaned}`;
};
interface VideosFormProps {
  formData: any;
  setFormData: (data: any) => void;
  handleBack?: () => void;
  handleSave?: () => void;
  title?: string;
}

const UploadBox = styled(Box)<BoxProps>({
  border: "2px dashed #ccc",
  borderRadius: "10px",
  padding: "20px",
  textAlign: "center",
  cursor: "pointer",
  width: "100%",
  height: 150,
});

const VideoPreview = styled("video")({
  width: "160px",
  height: "100px",
  borderRadius: "8px",
  objectFit: "cover",
  backgroundColor: "#000",
});

const VideosForm: React.FC<VideosFormProps> = ({
  formData,
  setFormData,
  handleBack,
  handleSave,
  title = "Upload Videos (For Portfolio)",
}) => {
  const [videos, setVideos] = useState<File[]>([]); // newly added files
  const [uploadedVideos, setUploadedVideos] = useState<any[]>(
    formData.videos?.filter((f: any) => typeof f === "string" || f.media) || []
  );
  const [loading, setLoading] = useState(false);

  // Handle new file upload
  const handleVideoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files) return;

    const fileArray = Array.from(files);
    setVideos((prev) => [...prev, ...fileArray]);

    // Merge into formData
    setFormData((prev: any) => ({
      ...prev,
      videos: [
        ...uploadedVideos, // existing prefilled videos
        ...prev.videos.filter((f: any) => f instanceof File), // previous new files
        ...fileArray, // newly selected files
      ],
    }));
  };

  // Remove newly added video
  const handleRemoveVideo = (index: number) => {
    const updated = videos.filter((_, i) => i !== index);
    setVideos(updated);

    setFormData((prev: any) => ({
      ...prev,
      videos: [
        ...uploadedVideos,
        ...prev.videos.filter((f: any) => f instanceof File && !videos.includes(f)),
      ],
    }));
  };
useEffect(() => {
    if (!formData.providerId) {
    console.log("No formData.id present, skipping fetch");
    return;
  }

  const fetchPortfolio = async () => {
    if (!formData.providerId) return;
    try {
      const res = await GetApiMethod(`provider-portfolio/list?id=${formData.providerId}`);
      if (res.data.status === "success" && Array.isArray(res.data.data.records)) {
        console.log("Raw portfolio records:", res.data.data.records);
      const backendvideos = res.data.data.records
  .filter((p: any) => p.mediaType && p.mediaType.startsWith("video")) // Only images
  .map((p: any) => ({
    id: p.id,
    media: p.mediaUrl || p.media,
    mediaType: p.mediaType,
  }));


        console.log("Mapped backend photos:", backendvideos);
        setUploadedVideos(backendvideos);

        // Keep only File objects from formData
        const files = formData.photos?.filter((f: any) => f instanceof File) || [];

        // Merge cleanly
        setFormData((prev: FormDataType) => ({
          ...prev,
          photos: [...backendvideos, ...files],
        }));
      }
    } catch (err) {
      console.error("Failed to fetch portfolio:", err);
    }
  };
  fetchPortfolio();
}, [formData.providerId]);
  // Delete already uploaded video
const handleDeleteUploadedVideo = async (index: number) => {
  try {
    const videoToDelete = uploadedVideos[index];
    if (!videoToDelete?.id) {
      console.error("No video ID found for deletion");
      return;
    }

    const response = await DeleteApiMethod(`provider-portfolio/${videoToDelete.id}`);

    if (response?.data?.status === "success") {
      const updatedVideos = uploadedVideos.filter((_, i) => i !== index);
      setUploadedVideos(updatedVideos);

      setFormData((prev: any) => ({
        ...prev,
        videos: updatedVideos,
      }));
    } else {
      alert("Failed to delete video.");
    }
  } catch (err) {
    console.error(err);
    alert("Failed to delete video.");
  }
};


  // Handle Save
  const handleSaveVideos = () => {
    if (!handleSave) return;

    setFormData((prev: any) => ({
      ...prev,
      videos: [...uploadedVideos, ...videos],
    }));

    handleSave();
  };

  return (
    <Box>
      <Typography className="form-input" mt={3}>
        {title}
      </Typography>

      <UploadBox component="label">
        <img src={videoIcon} alt="upload" style={{ marginTop: 15, width: 40 }} />
        <Typography fontSize="14px" mt={1} fontFamily="Poppins">
          Drag and drop videos or{" "}
          <span style={{ color: "#3E93E8", cursor: "pointer" }}>Choose file</span>
        </Typography>
        <input type="file" hidden accept="video/*" multiple onChange={handleVideoUpload} />
      </UploadBox>

      {/* New uploaded previews */}
      <Box display="flex" gap={2} flexWrap="wrap" mb={3} mt={2}>
      {videos.map((video, index) => (
  <Box key={index} position="relative" display="inline-block">
    <VideoPreview controls src={URL.createObjectURL(video)} />
    <IconButton
      size="small"
      onClick={() => handleRemoveVideo(index)}
      sx={{ position: "absolute", top: "-10px", right: "-10px", backgroundColor: "white" }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>
))}
      </Box>

      {/* Existing uploaded videos */}
     {uploadedVideos.map((video, index) => (
  <Box key={video.id || video.media} position="relative" display="inline-block">
    <VideoPreview controls src={normalizeMediaUrl(video.media || video)} />
    <IconButton
      size="small"
      onClick={() => handleDeleteUploadedVideo(index)}
      sx={{ position: "absolute", top: "-10px", right: "-10px", backgroundColor: "white" }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>
))}

      <Box display="flex" justifyContent="start" gap={2} mt={3}>
        {handleBack && (
          <Button onClick={handleBack} className="btn-back">
            <Box component="img" src={GroupIcon} sx={{ mr: 1 }} />
            Back
          </Button>
        )}
        <Button onClick={handleSaveVideos} className="btn-next" disabled={loading}>
          {loading ? <CircularProgress size={20} /> : "Save"}
        </Button>
      </Box>
    </Box>
  );
};

export default VideosForm;
